<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction">
      <wt-form-table-list ref="integialTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
      </wt-form-table-list>
    </wt-form-table>
    <!-- 授予 -->
    <grant-dialog :visible="dialogVisible" :integralValidateForm="integralValidateForm" @submitForm="submitForm" @handleClose="handleClose"></grant-dialog>
    <!-- 扣除 -->
    <cut-dialog :visible="cutDialogVisible" :cutValidateForm="cutValidateForm" @submitForm="submitCutForm" @handleClose="handleCutClose"></cut-dialog>

  </div>
</template>

<script>
import request from '@/utils/request'
import GrantDialog from './grant'
import CutDialog from './cut'

export default {
  components: { GrantDialog, CutDialog },
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_USERINTEGRALDETAILS',
        formComponent: {
          view: { type: 'component', componentName: 'UserIntegralDetails-view', value: 'queryUserIntegralDetailsDetailData', noRequest: true },
          add: { type: 'component', componentName: 'UserIntegralDetails-edit', value: 'resetUserIntegralDetailsDetailData' },
          edit: { type: 'component', componentName: 'UserIntegralDetails-edit', value: 'queryUserIntegralDetailsDetailData' },
          list: { type: 'default', value: '/modules/userIntegralDetails/userIntegralList' },
          delete: { type: 'default', value: '/modules/userIntegralDetails/userIntegralDetailsDelete' }
        },
        formInputsData: [
          { name: '手机号', key: 'keyWord', value: '', type: 'text' },
          { name: '社区', key: 'communityId', value: '', type: 'select', data: [] }],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/userIntegralDetails/userIntegralListImport',
          fileName: '用户积分',
          permission: 'EXPORT' }],
        formTableData: [
          { name: '昵称', key: 'nickName', type: 'text' },
          { name: '手机号', key: 'phone', type: 'text' },
          { name: '社区', key: 'communityName', type: 'text' },
          { name: '总积分', key: 'residueIntegral', type: 'text' }],
        formTableButtonsData: [{ name: '查看', key: 'VIEW', action: 'VIEW', className: 'primary', hidden: false, permission: 'VIEW' },
          { name: '授予', key: 'GRANT', action: 'GRANT', className: 'primary', hidden: false, permission: 'GRANT' },
          { name: '扣除', key: 'CUT', action: 'CUT', className: 'primary', hidden: false, permission: 'CUT' }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: true, index: true }
      },
      dialogVisible: false,
      integralValidateForm: {
        integral: 0,
        reason: '',
        userId: '',
        siteId: ''
      },
      cutDialogVisible: false,
      cutValidateForm: {
        integral: 0,
        reason: '',
        userId: '',
        siteId: ''
      },
      props: { multiple: true, children: 'siteResultList', label: 'name', value: 'id', emitPath: false },
      options: []
    }
  },
  mounted() {
    this.requestcommunityList()
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      console.log('data', data)
      if (data && data.item) {
        if (data.item.action === 'VIEW') {
          this.$store.dispatch('setUserIntegralDetailsDetailData', data.row)
        }
        if (data.item.action === 'GRANT') {
          this.integralValidateForm.reason = ''
          this.integralValidateForm.integral = ''
          this.integralValidateForm.siteId = ''
          this.integralValidateForm.userId = data.row.userId
          this.dialogVisible = true
        }
        if (data.item.action === 'CUT') {
          this.cutValidateForm.reason = ''
          this.cutValidateForm.integral = ''
          this.cutValidateForm.siteId = ''
          this.cutValidateForm.userId = data.row.userId
          this.cutDialogVisible = true
        }
      }
    },
    submitForm(formName) {
      const that = this
      this.$wtUtil.deleteConfirm(this, `您确认为该用户充值 ${this.integralValidateForm.integral} 积分吗？`).then(() => {
        request({
          url: '/modules/userIntegralDetails/userIntegralAdd',
          method: 'post',
          data: this.integralValidateForm
        }).then(res => {
          if (res.code === '0') {
            that.$message({ message: '保存成功', type: 'success' })
            this.$refs.integialTableRef.requestList()
            that.handleClose()
          }
        })
      })
    },
    submitCutForm() {
      const that = this
      this.$wtUtil.deleteConfirm(this, `您确认扣除该用户 ${this.cutValidateForm.integral} 积分吗？`).then(() => {
        request({
          url: '/modules/userIntegralDetails/userIntegralRemove',
          method: 'post',
          data: that.cutValidateForm
        }).then(res => {
          if (res.code === '0') {
            that.$message({ message: '操作成功', type: 'success' })
            that.$refs.integialTableRef.requestList()
            that.handleCutClose()
          }
        })
      })
    },
    handleClose() {
      this.dialogVisible = false
    },
    handleCutClose() {
      this.cutDialogVisible = false
    },

    /*  ------------------------- 接口请求  -------------------------  */
    requestcommunityList() {
      request({
        url: '/modules/community/communityNoPageList',
        method: 'post'
      }).then(res => {
        if (res.code === '0') {
          for (const item of res.data) {
            item.label = item.name
            item.value = item.id
          }
          this.form.formInputsData[1].data = res.data
        }
      })
    }
  }
}
</script>
